import css from '../tpl-css/style-section-banner.js';
const html = `
<style>${css}</style>
<div data-attribute="card-container" data-id="unique-id" data-background="#FFFFFF" style="background-color: rgb(255, 255, 255);">
    <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
        style="background-color: transparent;">
        <div class="wrap-card">
            <div class="swiper banner-slider mySwiperBannerSlider-unique-id">
                <div data-attribute="list-item" class="swiper-wrapper">
                    <div data-attribute="item" class="swiper-slide">
                        <div data-attribute="wrap-content" class="wrap-ct">
                            <div class="wrap-img">
                                <img data-attribute="image-banner"
                                    src="https://manchestore.com/cdn/shop/files/PC7.jpg?v=1753156711" alt="">
                            </div>
                            <div class="wrap-text-btn">
                                <div data-show-text="true" data-attribute="text-banner" class="wrap-text"
                                    style="display: block;">
                                    <h2>Buy 2 get 5% off</h2>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
                                </div>
                                <div data-show-button="true" data-attribute="button-banner" class="wrap-btn"
                                    style="display: block;">
                                    <a data-background="#000000" data-color="#FFFFFF" style="background-color: #000000; color: #FFFFFF;" data-attribute="button-link" class="btn-slide" href="#">Buy Now</a>
                                </div>
                            </div>
                            <div data-show-overlay="true" data-opacity="0.2" data-attribute="overlay-slide" class="slide-overlay"
                                style="background-color: black; opacity: 0.2; display: block;"></div>
                        </div>
                    </div>
                    <div data-attribute="item" class="swiper-slide">
                        <div data-attribute="wrap-content" class="wrap-ct">
                            <div class="wrap-img">
                                <img data-attribute="image-banner"
                                    src="https://manchestore.com/cdn/shop/files/PC7.jpg?v=1753156711" alt="">
                            </div>
                            <div class="wrap-text-btn">
                                <div data-show-text="true" data-attribute="text-banner" class="wrap-text"
                                    style="display: block;">
                                    <h2>Buy 2 get 5% off</h2>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
                                </div>
                                <div data-show-button="true" data-attribute="button-banner" class="wrap-btn"
                                    style="display: block;">
                                    <a data-background="#000000" data-color="#FFFFFF" style="background-color: #000000; color: #FFFFFF;" data-attribute="button-link" class="btn-slide" href="#">Buy Now</a>
                                </div>
                            </div>
                            <div data-show-overlay="true" data-opacity="0.2" data-attribute="overlay-slide" class="slide-overlay"
                                style="background-color: black; opacity: 0.2; display: block;"></div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>
</div>
`;
export default html;
